/**
 * CPL (centipawn loss) to estimated rating correlation table.
 * Ported from the Python prototype's estimate_rating.py.
 * Linear interpolation is applied between adjacent data points.
 */
export const CPL_TO_RATING_TABLE: ReadonlyArray<readonly [cpl: number, rating: number]> = [
  [10, 2600],
  [25, 2200],
  [40, 1800],
  [60, 1500],
  [80, 1300],
  [100, 1100],
  [130, 900],
  [170, 750],
  [220, 600],
  [300, 450],
  [400, 350],
  [500, 250],
] as const;

export const BLUNDER_THRESHOLD_CP = 200;
export const MISTAKE_THRESHOLD_CP = 100;

/** Maps average centipawn loss to a rough single-game performance estimate. */
export function estimateRatingFromCpl(cpl: number): number {
  if (!Number.isFinite(cpl)) return 0;
  if (cpl <= CPL_TO_RATING_TABLE[0][0]) return CPL_TO_RATING_TABLE[0][1];
  const last = CPL_TO_RATING_TABLE[CPL_TO_RATING_TABLE.length - 1];
  if (cpl >= last[0]) return last[1];

  for (let i = 1; i < CPL_TO_RATING_TABLE.length; i += 1) {
    const [upperCpl, upperRating] = CPL_TO_RATING_TABLE[i];
    const [lowerCpl, lowerRating] = CPL_TO_RATING_TABLE[i - 1];
    if (cpl <= upperCpl) {
      const progress = (cpl - lowerCpl) / (upperCpl - lowerCpl);
      return Math.round(lowerRating + progress * (upperRating - lowerRating));
    }
  }
  return last[1];
}
